/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Github_Client_SecretInputs */

const en_admin_settings_fields_github_client_secret = /** @type {(inputs: Admin_Settings_Fields_Github_Client_SecretInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client Secret`)
};

/**
* | output |
* | --- |
* | "Client Secret" |
*
* @param {Admin_Settings_Fields_Github_Client_SecretInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_github_client_secret = /** @type {((inputs?: Admin_Settings_Fields_Github_Client_SecretInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Github_Client_SecretInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_github_client_secret(inputs)
});
export { admin_settings_fields_github_client_secret as "admin.settings.fields.github_client_secret" }